module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq673-f7a06157031e320f4d54bdbf2db7d937.jpg";